import { defineComponent } from "vue";
import common from "../core/core";
import countriesPhoneCodes from "../assets/json/countries-phone-codes.json";

export default defineComponent({
  template: `
                <VDropdown
                    :shown="show"
                    :triggers="[]"
                    auto-hide
                    @hide="hide"
                    style="height: 3.75rem; margin-bottom: -3.75rem;"
                    popper-class="phone-block__country-code-dropdown"
                >
                    <template #popper>
                            <button @click="update(id, country)" v-close-popper v-for="country in this.countryOptions" :key="country.countryCode">
                                <span :class="'phone-block__country-flag fflag fflag-' + country.country_code"></span> <span class="text-gray-60 d-inline-block" style="width: 3.5rem">{{ country.phone_code }}</span> {{ country.name }}
                            </button>
                    </template>
                </VDropdown>
    `,
  data() {
    return {
      countryOptions: countriesPhoneCodes,
    };
  },
  props: ["show", "id", "update", "hide"],
  mixins: [common],
});
